export default {
  officeNo: '供应商',
  requiredOfficeNo: '请选择供应商',
  purchaseUnitNo: '采购中心',
  startDate: '开始日期',
  endDate: '结束日期',
  dateRange: '日期范围',
  chaseChgDate: '变更日期',
  deliveryDate: '交货日期',
  datePicker: '日期',
  requiredDateRange: '请选择日期范围',
  startTimeDate: '开始日期',
  endTimeDate: '结束日期',
  dateTimeRange: '日期范围',
  requiredDateTimeRange: '请选择日期范围'
}
